import React from "react";
import AlphaherdNftCard from "../../component/shared/card/alphaherd.nftCard";
import AlphaherdSectionContentCard from "../../component/shared/card/alphaherd.sectionContentCard";
import { proceedsFromData } from "./data";

const AlphaherdProceedFromSection = () => {
  return (
    <section className="alpha_proceedsfrom_section">
      <div className="section_proceeds_overly"></div>
      <div className="container">
        <div className="section_wrapper">
          {proceedsFromData.map((d) => (
            <>
              <div className="row">
                <div className="col-md-12 section_content">
                  <AlphaherdSectionContentCard
                    subTitle={d.subTitle}
                    title={d.title}
                    description={d.description}
                  />
                </div>
              </div>
              <div className="nft_image_box">
                <div className="row">
                  <div className="col-md-8">
                    <div className="nft_content_box">
                      {d.nft_contents.map((img, i) => (
                        <AlphaherdNftCard
                          key={i + 1}
                          animDir="fade-up"
                          animDelay={`${i + 5}00`}
                          nftContent={true}
                          count={img.count}
                          percent={img.percent}
                          description={img.description}
                        />
                      ))}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="single_image">
                      <AlphaherdNftCard
                        animDir="fade-up"
                        animDelay={`900`}
                        img={d.image}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AlphaherdProceedFromSection;
